// extracted by mini-css-extract-plugin
export default {"tag":"styles_tag__HrYae","tag_type_orange":"styles_tag_type_orange__gVkYq","tag_type_green":"styles_tag_type_green__pzlig","tag_type_violet":"styles_tag_type_violet__HvN9L"};